export default "__VITE_ASSET__CHyEIZiw__"